// extracted by mini-css-extract-plugin
module.exports = {"illustration":"sign_up_illustration__1HO0B"};